import { jsx as _jsx } from "react/jsx-runtime";
import DownloadMobileApp from '@domain/DownloadMobileApp/DownloadMobileApp';
import { styled } from '@mui/material/styles';
const StyledContainer = styled('div') `
  margin-top: 72px;
`;
const ChallengeLandingPage = () => {
    return (_jsx(StyledContainer, { children: _jsx(DownloadMobileApp, { "data-testid": "download-mobile-app" }) }));
};
export default ChallengeLandingPage;
